export enum NotificationType {
  Notice, /// For normal use
  FacilityUserDeletion,
  NewSignIn,
  NewAppAccess,
  FailedLoginAttempt
}
